import { textToHtml } from '../utils/emailFormatting.js';

export const generateAlexanderReply = (artistData) => {
  // Extract name from nested artists_data or top level
  const artistName = artistData.name || artistData.artists_data?.name;

  const content = `Amanda —  

Thanks for sending this over -- I love their music. 
Data and projection checks out, though sonic conversion makes me think this is worth a direct approach.  

I'll reach out personally.  

cheers,

Alexander Almgren

(917)-719-1555
Producer / Mixer / Master-er
https://freshlybakedstudios.com
instagram.com/alexanderalmgren`;

  return {
    subject: `Re: Quick Flag — ${artistName}`,
    from: "almgren@freshlybakedstudios.com", 
    to: "goldfarb@freshlybakedstudios.com",
    content,
    htmlContent: textToHtml(content)
  };
};
